import PropTypes from 'prop-types'
import { Text } from '@leroy-merlin-br/backyard-react-ui'

import { Notification } from 'checkout/components/Notification'

import ProductDetails from './Details'
import * as S from './styled'

const Product = ({
  animationKeys: {
    hideProduct = false,
    animation = false,
    showDisclaimer = false
  },
  product,
  isMobile,
  removeProduct,
  updateProduct,
  services,
  regionId,
  availableServices
}) => {
  const { productUrl, thumbUrl } = product

  return (
    <S.Wrapper fadeIn={product?.fadeIn} data-cy="minicart-product">
      {
        !hideProduct && [
          <S.Line key={'productLine'} />,
          <S.AnimatedWrapper key={'animatedWrapper'} fadeOut={animation}>
            <a href={productUrl}>
              <S.ProductImg src={thumbUrl} />
            </a>
            <ProductDetails
              isMobile={isMobile}
              {...product}
              regionId={regionId}
              removeProduct={removeProduct}
              updateProduct={updateProduct}
              services={services}
              availableServices={availableServices}
            />
          </S.AnimatedWrapper>
        ]
      }
      <Notification type={'success'} close={!showDisclaimer}>
        <Text size="kilo" noMargin>
          Produto removido com sucesso.
        </Text>
      </Notification>
    </S.Wrapper>
  )
}

Product.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      thumbUrl: PropTypes.string,
      productUrl: PropTypes.string,
      externalId: PropTypes.number,
      packaging: PropTypes.number,
      unit: PropTypes.string,
      price: PropTypes.shape({
        from: PropTypes.number,
        to: PropTypes.number,
        total: PropTypes.number
      }),
      quantity: PropTypes.number
    })
  )
}

export default Product
